import { render, staticRenderFns } from "./timedout.pug?vue&type=template&id=704e5914&lang=pug&"
import script from "./timedout.js?vue&type=script&lang=js&"
export * from "./timedout.js?vue&type=script&lang=js&"
import style0 from "./timedout.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lauramunozruiz/multiasistencia/selfcarefront/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704e5914')) {
      api.createRecord('704e5914', component.options)
    } else {
      api.reload('704e5914', component.options)
    }
    module.hot.accept("./timedout.pug?vue&type=template&id=704e5914&lang=pug&", function () {
      api.rerender('704e5914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/timedout/index.vue"
export default component.exports